var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgTiret = function SvgTiret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 2,
    viewBox: "0 0 4 2",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M3.69922 0.554688V1.375H0.300781V0.554688H3.69922Z"
  })));
};
export default __webpack_public_path__ + "assets/3a4bbf0a2cb79a9e741287f9e46eeb4a.svg";
export { SvgTiret as ReactComponent };


// WEBPACK FOOTER //
// ./components/inputs/Checkbox/icons/tiret.svg